import React from "react";
import "./loader.css";
import LogoAnimated from "../LogoAnimated";

const Loader = () => {
  return (
    <div className="loader">
      <LogoAnimated
        src="./assets/images/1755medium.png"
        wrapClassName="loader-img"
        imgStyle={{ borderRadius: "100%" }}
        alt=""
      />
    </div>
  );
};

export default Loader;
